import { getLanguageDisplay } from '@supply-mover-2-0/core';
import { cn } from '@supply-mover-2-0/web-ui';
import type { JSX } from 'react';
import { CountryFlag } from './CountryFlag';

interface LanguageMarkProps {
	code: string;
	name?: string | null;
	/** Size classes for the flag, e.g. `h-4 w-6`. */
	className?: string;
}

/**
 * The small visual beside a language in the switcher: its country flag.
 *
 * PD-16672 — the owner chose flags for every language (2026-09-30). Chinese
 * goes by script: Simplified Chinese shows China's flag and Traditional
 * Chinese shows Hong Kong's (see `flagCountryFor`). The flag is labeled with
 * the language's own name for screen readers.
 */
export function LanguageMark({
	code,
	name,
	className,
}: LanguageMarkProps): JSX.Element {
	const display = getLanguageDisplay({ code, name });

	return (
		<CountryFlag
			code={code}
			className={cn(
				'rounded-sm shadow-[0_0_0_1px_rgba(0,0,0,0.1)] shrink-0',
				className,
			)}
			title={display.nativeName}
		/>
	);
}
